import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'
import { getType, handleApi } from '@/utils/common.js'

export default {
  state: {},
  mutations: {
    getRenewalList(state, data) {
      data.url = API.renewal.getRenewalList
      CommonUtils.PostRequest(data)
    },
    uploadRenewalExcel(state, data) {
      data.url = API.renewal.uploadRenewalExcel
      CommonUtils.PostRequest(data)
    },
    getRenewalDetail(state, data) {
      data.url = API.renewal.getRenewalDetail
      CommonUtils.GetRequest(data)
    },
    getRenewalUploadLogList(state, data) {
      data.url = API.renewal.getRenewalUploadLogList
      CommonUtils.GetRequest(data)
    },
    getExcelFailLogList(state, data) {
      data.url = API.renewal.getExcelFailLogList
      CommonUtils.GetRequest(data)
    },
    getExcelFile(state, data) {
      data.url = API.renewal.excelFile
      CommonUtils.PostRequest(data)
    },
    getSelectOptions(state, data) {
      data.url = API.renewal.getSelectOptions
      CommonUtils.GetRequest(data)
    },
    updateRenewalStage(state, data) {
      data.url = API.renewal.updateRenewalStage
      CommonUtils.PostRequest(data)
    },
    getRenewalInfo(state, data) {
      data.url = handleApi(API.renewal.getRenewalInfo, getType('renewal_policy_detail', 'renewal_policy_detail_secret', 'renewal_policy_detail_part'))
      // data.url = API.renewal.getRenewalInfo
      CommonUtils.GetRequest(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/renewal.js